export default {
  app: {
    title: 'LYLUP',
    admin: 'Admin Panel'
  },
  validation: {
    required: 'Ovo polje je obavezno.',
    endDateAfterStartDate: 'Datum završetka mora biti nakon datuma početka.',
    invalidImageUuid: 'Neispravan ID slike.',
  },
  navigation: {
    dashboard: 'Kontrolna ploča',
    establishments: 'Objekti',
    locations: 'Lokacije',
    complexes: 'Kompleksi',
    menus: 'Ponuda',
    news: 'Novosti',
    customers: 'Korisnici',
    promo: 'Promo kodovi',
    membership: 'Članstva',
    rewards: 'Nagrade',
    admins: 'Administratori',
    employees: 'Zaposlenici',
    logout: 'Odjava',
    project: 'Projekt',
    loadingProjects: 'Učitavanje projekata…',
    selectProject: 'Odaberi projekt',
    createProject: 'Kreiraj projekt',
    projectName: 'Naziv projekta',
    manageProjects: 'Upravljanje projektima',
    noProjects: 'Nema dostupnih projekata',
    noProjectsHint: 'Kreiraj prvi projekt u upravljanju projektima.',
    projectRequiredSidebarTitle: 'Nema projekata — prvo dodaj projekt.',
    navLockedUntilProject: 'Dostupno nakon što kreiraš barem jedan projekt (Administratori → Projekti).',
    onboardingNavHint: 'Postavljanje sustava: najprije kreiraj projekt, zatim ostale module.',
    noProjectMembershipTitle: 'Nemate dodijeljen pristup projektu',
    noProjectMembershipMessage: 'Molimo obratite se administratoru radi dodjele na projekt. Bez aktivne dodjele moduli sustava nisu dostupni.',
    noProjectMembershipNavHint: 'Izbornik je onemogućen dok vas administrator ne dodijeli barem na jedan projekt.',
    viewerModeBanner: 'Način samo za čitanje — na ovom projektu imate ulogu preglednika; kreiranje i uređivanje nisu dostupni.',
    viewerActionDisabledHint: 'Nemate dopuštenje za tu radnju — uloga na projektu je samo za pregled.',
    licenseInvalidTitle: 'Potrebna je licenca',
    licenseInvalidMessage: 'Vaša licenca nedostaje ili više nije valjana. Kontaktirajte administratora sustava za obnovu pristupa.',
    licenseInvalidGoProfile: 'Idi na profil'
  },
  license: {
    errors: {
      LICENSE_MISSING: 'Nemate aktivnu licencu. Molimo kontaktirajte administratora sustava.',
      LICENSE_EXPIRED: 'Vaša licenca je istekla. Molimo obnovite licencu.',
      LICENSE_SUSPENDED: 'Vaša licenca je privremeno suspendirana. Molimo kontaktirajte administratora sustava.'
    },
    banner: {
      missing: 'Nema aktivne licence — upravljanje sustavom je onemogućeno.',
      expired: 'Licenca je istekla — upravljanje sustavom je onemogućeno.',
      suspended: 'Licenca je suspendirana — upravljanje sustavom je onemogućeno.',
      inactive: 'Licenca nije aktivna — upravljanje sustavom je onemogućeno.'
    }
  },
  dashboard: {
    welcome: 'Dobrodošao natrag,',
    accountTypeSuperadmin: 'Superadmin',
    accountTypeAdmin: 'Račun: administrator',
    locationsDescription: 'Brzo odaberi lokaciju.',
    openLocation: 'Otvori',
    quickAdd: 'Brzo dodavanje',
    quickAddDescription: 'Brzo dodajte nove stavke.',
    addEstablishment: 'Novi objekt',
    addLocation: 'Lokacije',
    addMenuItem: 'Nova stavka',
    addNews: 'Nova novost',
    addPromoCode: 'Novi promo kod',
    addMembership: 'Novo članstvo',
    addReward: 'Nova nagrada',
    addOfficeAdmin: 'Novi office admin',
    adminTools: 'Administratorski alati',
    totalAdmins: 'Ukupno administratora',
    openApiDocs: 'API dokumentacija (Swagger)',
    openApiDocsSubtitle: 'Otvara se u novoj kartici preglednika',
    openApiDocsTitle: 'HTTP Basic auth koristi pristupne podatke za Swagger na serveru',
    kpi: {
      totalRevenue: 'Ukupni prihod',
      totalOrders: 'Narudžbe',
      totalCustomers: 'Korisnici',
      totalItems: 'Prodane stavke',
      today: 'Danas',
      itemsSold: 'Završene narudžbe'
    },
    filters: {
      title: 'Filteri',
      dateRange: 'Period',
      location: 'Lokacija',
      allLocations: 'Sve lokacije',
      teamScope: 'Tim i vlasnici',
      assignedAdmin: 'Suradnik (dodjela objekata)',
      allTeamMembers: 'Svi članovi tima',
      projectOwnerFilter: 'Vlasnik projekta (sustav)',
      allProjectOwners: 'Svi vlasnici',
      reset: 'Poništi',
      export: 'Izvezi'
    },
    quickAccess: 'Brzi pristup',
    yourNetwork: 'Tvoja mreža',
    yourNetworkDescription: 'Pregled objekata i lokacija.',
    locationsModalTitle: 'Sve lokacije – pretraga i pregled',
    activeFiltersNote: 'Prikazani podaci odražavaju odabrani period, lokaciju i filter tima / vlasnika (ako je zadan).'
  },
  customers: {
    title: 'Korisnici',
    description: 'Pregled i upravljanje korisnicima (gostima)',
    searchPlaceholder: 'Ime, email, telefon...',
    loading: 'Učitavanje korisnika...',
    noResults: 'Nema korisnika',
    noResultsSearch: 'Nema rezultata za pretragu',
    emptyDescription: 'Korisnici će se pojaviti ovdje kada se registriraju u aplikaciji.',
    name: 'Ime i prezime',
    email: 'Email',
    phone: 'Telefon',
    status: 'Status',
    createdAt: 'Registriran',
    view: 'Pregledaj',
    details: 'Detalji korisnika',
    edit: 'Uredi',
    backToList: 'Natrag na listu',
    basicInfo: 'Osnovni podaci',
    firstName: 'Ime',
    lastName: 'Prezime',
    birthDate: 'Datum rođenja',
    gender: 'Spol',
    city: 'Grad',
    save: 'Spremi',
    analytics: 'Analitika',
    totalOrders: 'Ukupno narudžbi',
    completedOrders: 'Završene narudžbe',
    totalSpent: 'Ukupna potrošnja',
    loyaltyPoints: 'Loyalty bodovi',
    loyaltySourceCard: 'Kartica (po objektu)',
    loyaltySourceEstablishment: 'Bodovi po objektu',
    loyaltySourceComplex: 'Bodovi po kompleksu',
    loyaltySourceCardAggregate: 'Ukupno na kartici',
    statusActive: 'Aktivan',
    statusPending: 'Na čekanju',
    statusSuspended: 'Suspendiran',
    statusRejected: 'Odbijen',
    tryDifferentSearch: 'Pokušajte s drugačijim pojmom za pretraživanje',
    noAnalytics: 'Nema dostupnih podataka o analitici',
    analyticsFiltersTitle: 'Filteri analitike',
    resetAnalyticsFilters: 'Poništi filtere',
    applyAnalyticsFilters: 'Primijeni filtere',
    dateFrom: 'Datum od',
    dateTo: 'Datum do',
    completionRate: 'Stopa završetka',
    averageOrderValue: 'Prosječna vrijednost narudžbe',
    ordersByDay: 'Narudžbe po danu',
    spentByDay: 'Potrošnja po danu',
    ordersByStatus: 'Narudžbe po statusu'
  },
  promo: {
    title: 'Promo kodovi',
    description: 'Upravljanje popust kodovima po objektima',
    add: 'Dodaj promo kod',
    edit: 'Uredi promo kod',
    createNew: 'Novi promo kod',
    code: 'Kod',
    establishment: 'Objekt',
    filterByEstablishment: 'Filtriraj po objektu',
    allEstablishments: 'Svi objekti',
    discountType: 'Vrsta popusta',
    discountValue: 'Vrijednost popusta',
    discountPercentage: 'Postotak',
    discountFixed: 'Fiksni iznos',
    minOrderAmount: 'Min. iznos narudžbe',
    maxUses: 'Maks. broj korištenja',
    unlimited: 'Neograničeno',
    usedCount: 'Iskorišteno',
    validFrom: 'Vrijedi od',
    validTo: 'Vrijedi do',
    isActive: 'Aktivan',
    loading: 'Učitavanje promo kodova...',
    noResults: 'Nema promo kodova',
    noResultsFilter: 'Nema promo kodova za odabrani objekt',
    emptyDescription: 'Dodajte prvi promo kod za popuste i akcije.',
    emptyFilterDescription: 'Odaberite drugi objekt ili dodajte promo kod za ovaj objekt.',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovaj promo kod?',
    backToList: 'Natrag na listu',
    save: 'Spremi'
  },
  membership: {
    title: 'Članstva',
    description: 'Trajni popusti za članove. Gost može biti u jednom programu po projektu.',
    add: 'Dodaj članstvo',
    edit: 'Uredi članstvo',
    createNew: 'Novo članstvo',
    details: 'Detalji članstva',
    view: 'Otvori',
    name: 'Naziv',
    namePlaceholder: 'npr. Zlatni klub',
    scope: 'Opseg',
    scopeProject: 'Cijeli projekt (licenca)',
    scopeEstablishment: 'Objekt',
    scopeLocation: 'Lokacija',
    joinCode: 'Kod za aktivaciju',
    joinCodePlaceholder: 'npr. CLAN10',
    joinCodeHint: 'Kod se generira automatski. Gost ga unosi, skenira QR ili otvara link. Novi kod radiš na detaljima programa.',
    joinUrl: 'Link za aktivaciju',
    regenerateCode: 'Novi kod',
    qrTitle: 'QR kod za pridruživanje',
    qrHint: 'Gost skenira QR kamerom telefona ili otvori link — Lylup ga učlani. Isti kod može unijeti ručno u Račun → Članstvo. QR možeš preuzeti ili ispisati za kartice, stolove i letke.',
    copyCode: 'Kopiraj kod',
    copyLink: 'Kopiraj link',
    downloadQr: 'Preuzmi QR',
    printQr: 'Ispiši QR',
    printQrHint: 'Skeniraj QR i pridruži se klubu',
    members: 'Članovi',
    membersCount: 'Članovi',
    noMembers: 'Još nema članova.',
    joinedAt: 'Pridružen',
    maxMembers: 'Maks. broj članova',
    unlimited: 'Neograničeno',
    loading: 'Učitavanje članstava...',
    noResults: 'Nema membership programa',
    noResultsFilter: 'Nema programa za odabrani objekt',
    emptyDescription: 'Dodajte prvi program ako želite popuste za članove. Nije obavezno.',
    emptyFilterDescription: 'Odaberite drugi objekt ili dodajte program za ovaj opseg.',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovaj membership program? Članovi će izgubiti status.',
    backToList: 'Natrag na listu',
    backToDetails: 'Natrag na program',
    discountType: 'Vrsta popusta',
    discountValue: 'Vrijednost popusta',
    discountValuePercent: 'Postotak popusta',
    discountValueEuro: 'Iznos popusta',
    discountValuePercentHint: 'Popust u postotku na iznos narudžbe (1–100).',
    discountValueEuroHint: 'Fiksni iznos koji se oduzima od narudžbe.',
    discountPercentage: 'Postotak',
    discountFixed: 'Fiksni iznos',
    minOrderAmount: 'Min. iznos narudžbe',
    isActive: 'Aktivan',
    allEstablishments: 'Svi objekti',
    filterByEstablishment: 'Odaberi objekt',
    filterByLocation: 'Odaberi lokaciju',
    selectEstablishmentFirst: 'Najprije odaberite objekt',
    codeRegenerated: 'Novi kod je generiran. Stari kod više ne vrijedi.'
  },
  establishments: {
    title: 'Moji objekti',
    add: 'Dodaj objekt',
    edit: 'Uredi',
    view: 'Pregledaj',
    delete: 'Izbriši',
    active: 'Aktivno',
    inactive: 'Neaktivno',
    restaurant: 'Restoran',
    saveLocation: 'Spremi lokaciju',
    hotel: 'Hotel',
    bar: 'Bar / Kafić',
    other: 'Ostalo',
    confirmDelete: 'Jeste li sigurni da želite izbrisati ovaj objekt?',
    deleteWarning: 'Ova akcija je nepovratna i trajno briše objekt i sve vezane podatke.',
    deleteRelIntro: 'Povezani podaci koji će također biti obrisani:',
    deleteRelLocations: 'Lokacije',
    deleteRelDetails: 'Detalji lokacija',
    deleteRelWorkingHours: 'Radna vremena',
    deleteRelOfficeAdmins: 'Office admini',
    deleteRelOfficeAdminRefreshTokens: 'Refresh tokeni office admina',
    deleteRelOfficeAdminDeviceTokens: 'Device tokeni office admina',
    deleteRelPromoCodes: 'Promo kodovi',
    deleteRelUserEstablishments: 'Veze korisnik-objekt',
    deleteRelAdminEstablishments: 'Veze admin-objekt',
    deleteRelComplexLinks: 'Veze kompleks-objekt',
    deleteRelTransactions: 'Transakcije',
    deleteRelCardPoints: 'Card establishment points',
    deleteRelQrCodes: 'QR kodovi',
    deleteRelQrTransactions: 'QR transakcije',
    deleteRelOrders: 'Narudžbe',
    deleteRelOrderItems: 'Stavke narudžbi',
    deleteRelTables: 'Stolovi',
    deleteRelRewards: 'Nagrade',
    deleteRelUserRewards: 'Korisničke nagrade',
    deleteRelNews: 'Novosti',
    deleteRelNewsImages: 'Slike novosti',
    deleteRelMenuCategories: 'Kategorije menija',
    deleteRelMenuItems: 'Stavke menija',
    deleteError: 'Greška pri brisanju objekta. Molimo pokušajte ponovno.',
    allTypes: 'Svi tipovi',
    restaurants: 'Restorani',
    hotels: 'Hoteli',
    bars: 'Barovi',
    others: 'Ostalo',
    manageEstablishments: 'Upravljajte svojim objektima, lokacijama i njihovim podacima',
    tryDifferentSearch: 'Pokušajte s drugačijim pojmom za pretraživanje',
    addNewEstablishment: 'Dodajte novi objekt klikom na gumb "Dodaj objekt"',
    locations: 'Lokacija',
    deactivate: 'Deaktiviraj',
    activate: 'Aktiviraj',
    basicInfo: 'Osnovni podaci',
    created: 'Kreirano',
    lastUpdated: 'Zadnja izmjena',
    addLocation: 'Dodaj lokaciju',
    generateQr: 'Generiraj QR',
    qrModalTitle: 'QR kod objekta',
    noLocations: 'Nema dodanih lokacija',
    addFirstLocation: 'Dodajte prvu lokaciju za ovaj objekt',
    details: 'Detalji',
    newEstablishment: 'Novi objekt',
    editEstablishment: 'Uređivanje objekta',
    basicInfoSection: 'Osnovne informacije',
    basicInfoSectionLead: 'Naziv, tip i kratak opis koje korisnici vide u aplikaciji.',
    brandingSection: 'Vizualni identitet',
    brandingSectionLead: 'Logo, boja pozadine na kartici i široka naslovna slika za mobilnu aplikaciju.',
    onlineSection: 'Web i status objekta',
    onlineSectionLead: 'Vanjska poveznica i je li objekt aktivan za korisnike.',
    onlineStatusHint: 'Neaktivan objekt ne prikazuje se korisnicima u aplikaciji.',
    establishmentName: 'Naziv objekta',
    establishmentNamePlaceholder: 'npr. McDonald\'s, Hilton Hotels...',
    establishmentType: 'Tip objekta',
    establishmentDescription: 'Opis objekta',
    establishmentDescriptionPlaceholder: 'Unesite kratki opis objekta...',
    nameRequiredOneLocale: 'Unesite naziv na hrvatskom ili engleskom.',
    descriptionRequiredOneLocale: 'Unesite opis na hrvatskom ili engleskom.',
    website: 'Web stranica',
    websitePlaceholder: 'https://www.example.com',
    additionalInfoSection: 'Dodatne informacije',
    backToEstablishment: 'Natrag na detalje objekta',
    backToEstablishments: 'Natrag na objekte',
    saveEstablishment: 'Spremi objekt',
    saveChanges: 'Spremi promjene',
    logo: 'Logo',
    logoHint:
      'Manji znak brenda na karticama i u listama u aplikaciji. Preporuka: kvadrat ili PNG/SVG s transparentnom pozadinom.',
    dragAndDrop: 'Povucite i ispustite sliku ovdje',
    or: 'ili',
    chooseLogo: 'Odaberite sliku',
    invalidImageType: 'Odaberite sliku: JPEG, PNG, GIF, WebP ili SVG (npr. logo).',
    logoBackgroundColor: 'Boja pozadine logotipa (mobilna aplikacija)',
    logoBackgroundColorHint:
      'Koristi se iza transparentnog logotipa na karticama. Ostavite prazno za zadanu boju aplikacije. Format: #RRGGBB.',
    logoBackgroundColorPlaceholder: '#D8670C',
    logoBackgroundColorClear: 'Ukloni boju',
    logoBackgroundColorInvalid: 'Boja mora biti prazna ili točan hex u obliku #RRGGBB (npr. #D8670C).',
    heroImage: 'Naslovna slika',
    heroImageHint:
      'Veća slika za mobilnu aplikaciju (npr. zaglavlje, detalji restorana). Preporuka: široka fotografija; JPG, PNG ili WebP.',
    heroImageUploadWait: 'Pričekajte da se završi upload naslovne slike.',
    saveError: 'Došlo je do greške pri spremanju. Molimo pokušajte ponovno.',
    pointsSection: 'Bodovanje',
    pointsSectionLead: 'Program se postavlja na projektu; ovdje definiraš stope bodova za ovaj objekt.',
    pointsMode: 'Način skupljanja bodova',
    pointsModeInherited: 'Naslijeđeno s projekta',
    pointsModeInheritedHint: 'Program se mijenja u Administratori → Projekti. Objekti samo nasljeđuju postavku.',
    pointsModeCard: 'Loyalty kartica',
    pointsModeCardDescription: 'Bodovi se dodjeljuju pri skeniranju kartice ili ručnom unosu kupnje',
    pointsModeOrder: 'Automatski pri narudžbi',
    pointsModeOrderDescription: 'Bodovi se automatski dodjeljuju kad korisnik završi narudžbu',
    pointsPerEuroScan: 'Bodovi po 1 € (sken/ručni unos)',
    pointsPerEuroScanPlaceholder: '0.1',
    pointsPerEuroScanHelp: 'Npr. 0.1 znači 1 bod za svakih 10 €',
    pointsPerEuroOrder: 'Bodovi po 1 € (narudžba)',
    pointsPerEuroOrderPlaceholder: '1',
    pointsPerEuroOrderHelp: 'Npr. 1 znači 1 bod za svaki 1 €',
    pointsPerEuro: 'bodova po €',
    menuScopeSection: 'Opseg menija',
    menuScopeSectionLead: 'Jedan meni za cijeli objekt ili posebnosti po lokaciji.',
    menuScopeLabel: 'Kako se konfigurira ponuda',
    menuScopeGlobal: 'Globalni meni po objektu',
    menuScopeGlobalDescription: 'Sve lokacije ovog objekta koriste isti meni.',
    menuScopeLocation: 'Meni po lokaciji',
    menuScopeLocationDescription: 'Lokacije mogu imati svoje override postavke menija uz fallback na globalni meni.'
  },
  locations: {
    title: 'Lokacije',
    listDescription: 'Sve lokacije projekta — radno vrijeme, stolovi, POS i narudžbe namještaju se ovdje.',
    searchPlaceholder: 'Traži lokaciju, objekt ili adresu…',
    allEstablishments: 'Svi objekti',
    noEstablishmentsTitle: 'Nema objekata',
    noEstablishmentsMessage: 'Prvo dodajte objekt, zatim lokacije unutar njega.',
    noLocationsYetTitle: 'Još nema lokacija',
    noLocationsNeedEstablishmentMessage:
      'Lokacije se dodaju na objekt. Prvo kreirajte objekt, zatim na njemu dodajte lokaciju.',
    noLocationsTitle: 'Nema lokacija',
    noLocationsMessage: 'Još nema lokacija. Dodajte prvu lokaciju na objekt.',
    tryDifferentSearch: 'Pokušajte s drugim pojmom ili filterom.',
    unknownEstablishment: 'Nepoznat objekt',
    errorLoadingList: 'Greška pri učitavanju lokacija',
    newLocation: 'Nova lokacija',
    editLocation: 'Uređivanje lokacije',
    locationName: 'Naziv lokacije',
    locationNamePlaceholder: 'npr. Centar, Zapad...',
    addressAndContacts: 'Adresa i kontakti',
    address: 'Adresa',
    addressPlaceholder: 'Počnite tipkati za pretraživanje adrese...',
    addressHelp: 'Odaberite adresu iz prijedloga pretraživanja ili unesite geografsku širinu i dužinu ručno.',
    addressRequired: 'Molimo unesite adresu lokacije',
    coordinatesRequired: 'Odaberite adresu putem pretraživanja ili unesite geografsku širinu i dužinu.',
    googleMapsKeyMissing: 'Pretraživanje adrese nije dostupno jer VITE_GOOGLE_MAPS_API_KEY nije postavljen. Unesite geografsku širinu i dužinu ručno.',
    latitude: 'Geografska širina (Latitude)',
    longitude: 'Geografska dužina (Longitude)',
    email: 'Email',
    emailPlaceholder: 'primjer: info.lokacija.hr',
    phone: 'Broj telefona',
    phonePlaceholder: '+385 01 234 5678',
    workingHours: 'Radno vrijeme',
    dayFrom: 'Od dana',
    dayTo: 'Do dana',
    timeFrom: 'Od',
    timeTo: 'Do',
    addWorkingHours: 'Dodaj još jedno radno vrijeme',
    backToLocation: 'Natrag na detalje lokacije',
    backToLocations: 'Natrag na lokacije',
    backToEstablishment: 'Natrag na objekt',
    noOfficeAdminWarning: 'Nema aktivnog zaposlenika — narudžbe se neće vidjeti u aplikaciji',
    inviteOfficeAdmin: 'Pozovi zaposlenika',
    loadingLocation: 'Učitavanje lokacije...',
    contactDetails: 'Kontakt podaci',
    mapLocation: 'Lokacija na karti',
    noWorkingHours: 'Nema definiranog radnog vremena',
    locationNotAvailable: 'Podaci o lokaciji nisu dostupni',
    detailsNotAvailable: 'Detalji lokacije nisu dostupni',
    coordinatesNotAvailable: 'Geografske koordinate nisu dostupne',
    locationIdNotFoundInUrl: 'ID lokacije nije pronađen u URL-u',
    emptyApiResponse: 'Dobiven je prazan odgovor od API-ja',
    errorFetchingLocation: 'Greška pri dohvaćanju lokacije',
    notLoggedInOrSessionExpired: 'Niste prijavljeni ili je vaša sesija istekla. Molimo prijavite se ponovno.',
    locationNotFound: 'Lokacija nije pronađena.',
    errorLoading: 'Greška pri učitavanju',
    unknownError: 'Nepoznata greška',
    noServerResponse: 'Nema odgovora od servera. Molimo provjerite internetsku vezu.',
    days: {
      monday: 'Ponedjeljak',
      tuesday: 'Utorak',
      wednesday: 'Srijeda',
      thursday: 'Četvrtak',
      friday: 'Petak',
      saturday: 'Subota',
      sunday: 'Nedjelja'
    }
  },
  pos: {
    title: 'POS integracija',
    noIntegration: 'Nema konfigurirane POS integracije',
    noIntegrationDescription: 'Dodajte integraciju kako biste povezali lokaciju s POS sustavom.',
    addIntegration: 'Dodaj integraciju',
    editIntegration: 'Uredi integraciju',
    deleteIntegration: 'Ukloni integraciju',
    provider: 'POS sustav',
    selectProvider: 'Odaberite POS sustav',
    credentials: 'Pristupni podaci',
    credentialsDescription:
      'Za Remaris koristite ključeve: api_base_url, gm_api_key, register_id te po želji system_name. Podaci se pohranjuju na poslužitelju.',
    addCredential: 'Dodaj polje',
    credentialKeyPlaceholder: 'npr. api_key, username...',
    credentialValuePlaceholder: 'Unesite vrijednost',
    isActive: 'Integracija aktivna',
    status: 'Status',
    statusActive: 'Aktivna',
    statusInactive: 'Neaktivna',
    lastSync: 'Zadnja sinkronizacija',
    lastSyncNever: 'Nikad',
    lastSyncError: 'Greška pri zadnjoj sinkronizaciji',
    syncMenu: 'Sinkroniziraj jelovnik',
    syncMenuDescription: 'Dohvatite artikle i cijene s POS sustava.',
    syncInProgress: 'Sinkronizacija u tijeku...',
    syncSuccess: 'Jelovnik uspješno sinkroniziran',
    syncFailed: 'Sinkronizacija nije uspjela',
    confirmDelete: 'Jeste li sigurni da želite ukloniti POS integraciju?',
    confirmDeleteWarning: 'Ova akcija će ukloniti integraciju i sva mapiranja artikala.',
    saveIntegration: 'Spremi integraciju',
    integrationCreated: 'POS integracija uspješno kreirana',
    integrationUpdated: 'POS integracija uspješno ažurirana',
    integrationDeleted: 'POS integracija uspješno uklonjena',
    errorCreating: 'Greška pri kreiranju integracije',
    errorDeleting: 'Greška pri brisanju integracije',
    errorLoading: 'Greška pri učitavanju POS integracije',
    orderHubBaseUrl: 'Order Hub bazni URL (za konfiguraciju na POS-u)',
    posStoreId: 'Store ID',
    oneTimeApiKeyWarning:
      'Kopirajte ovaj API ključ sada — više se neće prikazati. Predajte ga Remarisu zajedno s Order Hub URL-om. Ako ste ga izgubili, koristite gumb za novi ključ (stari tada prestaje vrijediti).',
    orderingEnabled: 'Naručivanje za POS uključeno',
    testConnection: 'Testiraj Remaris SEO vezu',
    testConnectionOk: 'Remaris SEO veza uspjela',
    testConnectionFail: 'Remaris SEO veza nije uspjela',
    dismissOneTimeKey: 'Zatvori',
    providersLoadWarning:
      'Popis POS sustava s poslužitelja nije dostupan ili je prazan — prikazujemo poznatu opciju Remaris. Ako trebate sinkronizirano stanje u bazi, pokrenite migracije (seed pos_providers).',
    remarisCredentialsIntro:
      'Ova polja moraju točno odgovarati JSON ključevima koje backend šalje u Remaris SEO API (mapiranje 1:1).',
    remarisJsonKeyHint: 'Ključ u JSON-u',
    credentialsGenericDescription:
      'Za ostale POS sustave unesite parove ključ–vrijednost kako zahtijeva integracija.',
    remarisEditHint:
      'Polja su predpopunjena spremljenom konfiguracijom. Promijeni samo ono što treba.',
    credentialConfigured: 'Spremljeno',
    showCredential: 'Prikaži',
    hideCredential: 'Sakrij',
    copyCredential: 'Kopiraj',
    credentialCopied: 'Kopirano',
    credentialCopyFailed: 'Kopiranje nije uspjelo',
    credentialPlaceholder: 'Ostavi prazno da zadržiš postojeću vrijednost',
    remarisApiBaseUrl: 'Bazni URL Remaris Clouda',
    remarisApiBaseUrlHelp:
      'Puni URL s https:// — samo host Remaris Clouda, bez SEO putanje (npr. https://development.remaris.hr).',
    remarisGmApiKey: 'GM-ApiKey',
    remarisGmApiKeyHelp:
      'Vrijednost koja ide u HTTP zaglavlje GM-ApiKey pri pozivu Remaris SEO API-ja.',
    remarisRegisterId: 'Register ID',
    remarisRegisterIdHelp:
      'Šalje se kao query parametar RegisterId (točno taj naziv parametra na Remaris strani).',
    remarisSystemName: 'System name (opcionalno)',
    remarisSystemNameHelp:
      'Opcionalno. Remaris filtrira artikle po atributu — kriva vrijednost (npr. "test") vraća prazan meni. Ostavite prazno ako niste sigurni.',
    remarisFieldRequired: 'Obavezno polje: {field}',
    remarisFillAllRequired: 'Popunite sva obvezna Remaris polja (api_base_url, gm_api_key, register_id).',
    servusCredentialsIntro:
      'Ova polja odgovaraju Servus QR API-ju (HTTP Basic Auth + client_uid lokacije).',
    servusEditHint:
      'Pristupni podaci se iz sigurnosnih razloga ne prikazuju. Unesite ih ponovo samo ako želite zamijeniti spremljene vrijednosti.',
    servusApiBaseUrl: 'Bazni URL Servus API-ja',
    servusApiBaseUrlHelp:
      'Default: https://QROrder.servus-app.com:44500 — promijenite samo ako Servus koristi drugi host.',
    servusUsername: 'Korisničko ime (Basic Auth)',
    servusUsernameHelp: 'HTTP Basic Auth korisničko ime koje dobivate od Servusa.',
    servusPassword: 'Lozinka (Basic Auth)',
    servusPasswordHelp: 'HTTP Basic Auth lozinka — pohranjuje se sigurno na poslužitelju.',
    servusClientUid: 'Client UID lokacije',
    servusClientUidHelp:
      'UUID lokala u Servus sustavu (isti se koristi u GET /api/getmenu/{client_uid}).',
    servusFillAllRequired: 'Popunite sva obvezna Servus polja (username, password, client_uid).',
    testServusConnection: 'Testiraj Servus vezu',
    servusPushModelHelp:
      'Servus koristi push model — narudžbe iz mobilne aplikacije automatski se šalju na blagajnu. Nema Order Hub URL-a ni API ključa za blagajnu.',
    errors: {
      generic: 'Operacija s POS sustavom nije uspjela. Provjerite konfiguraciju i pokušajte ponovno.',
      credentials_missing: 'Nedostaju obavezni pristupni podaci. Provjerite sva polja integracije.',
      network_unavailable: 'Nije moguće uspostaviti vezu s Remaris Cloudom. Provjerite api_base_url (mora početi s https://) i mrežu.',
      remaris_invalid_base_url: 'api_base_url nije valjan — mora biti puni URL s https:// (npr. https://development.remaris.hr).',
      timeout: 'POS server nije odgovorio na vrijeme. Pokušajte ponovno za nekoliko minuta.',
      menu_empty: 'Remaris meni je prazan. Provjerite Register ID i System name — vrijednost poput "test" filtrira sve artikle.',
      menu_invalid: 'Odgovor POS sustava nije valjan meni. Provjerite pristupne podatke.',
      integration_missing: 'POS integracija za ovu lokaciju nije pronađena.',
      provider_unsupported: 'Odabrani POS sustav nije podržan.',
      servus_unauthorized: 'Servus je odbio prijavu — korisničko ime ili lozinka nisu ispravni.',
      servus_invalid_request:
        'Servus je odbio zahtjev. Provjerite Client UID lokacije (mora biti valjan UUID) i ostale podatke.',
      servus_not_found: 'Lokacija (Client UID) nije pronađena u Servus sustavu.',
      servus_forbidden: 'Nemate pristup ovoj lokaciji u Servus sustavu.',
      servus_server_error: 'Servus server trenutno nije dostupan. Pokušajte ponovno kasnije.',
      servus_order_rejected: 'Servus nije prihvatio narudžbu. Provjerite mapiranje artikala.',
      remaris_unauthorized: 'Remaris je odbio zahtjev — GM-ApiKey nije ispravan ili je istekao.',
      remaris_not_found: 'Remaris nije pronašao traženo naplatno mjesto. Provjerite Register ID.',
      remaris_server_error: 'Remaris server trenutno nije dostupan. Pokušajte ponovno kasnije.',
      remaris_invalid_menu: 'Remaris je vratio neočekivan oblik menija. Provjerite Register ID i API ključ.',
    },
    regenerateExternalApiKey: 'Novi API ključ za blagajnu',
    regenerateExternalApiKeyHelp:
      'Ako ste ključ izgubili ili ga trebate zamijeniti (npr. nakon curenja). Stari ključ odmah prestaje vrijediti — u Remaris konfiguraciju morate unijeti novi, inače neće raditi narudžbe s blagajne.',
    confirmRegenerateApiKeyTitle: 'Generirati novi API ključ?',
    confirmRegenerateApiKeyBody:
      'Stari ključ za Standard External Orders odmah prestaje raditi. Blagajna mora dobiti novi ključ i ostali podaci (Order Hub URL, Store ID) ostaju isti. Želite li nastaviti?',
    regenerateApiKeySuccess: 'Novi ključ je spreman — kopirajte ga sada i predajte osobi koja podešava Remaris.',
    regenerateApiKeyFail: 'Generiranje novog ključa nije uspjelo',
    mappings: {
      title: 'Mapiranje artikala (POS ↔ jelovnik)',
      subtitle:
        'Povezuje Lylup stavku s postojećim ID-jem artikla na blagajni. Ne kreira proizvod na Remarisu — za nove artikle koristi blagajnu + sync. Ručno mapiranje služi kad sync ne pogodi 1:1 ili trebaš ispraviti vezu.',
      addMapping: 'Dodaj mapiranje',
      noIntegrationTitle: 'POS integracija nije postavljena',
      noIntegrationDescription: 'Prvo dodajte i aktivirajte POS integraciju, zatim možete mapirati artikle.',
      emptyTitle: 'Nema mapiranih artikala',
      emptyDescription:
        'Mapiranja se obično popunjavaju automatski pri sinkronizaciji jelovnika. Ručno ih dodajete samo da povežete postojeću Lylup stavku s POS ID-jem — ne stvarate artikl na blagajni.',
      colMenuItem: 'Stavka jelovnika',
      colPOSArticleID: 'POS Article ID',
      colPOSArticleCode: 'POS Article Code',
      colPOSCategoryID: 'POS Category ID',
      colPOSIds: 'POS ID',
      colActions: 'Akcije',
      inApp: 'U aplikaciji',
      availabilityOn: 'Vidljivo u aplikaciji na ovoj lokaciji',
      availabilityOff: 'Skriveno u aplikaciji na ovoj lokaciji',
      menuItemMissing: '(stavka jelovnika izbrisana)',
      selectMenuItem: 'Odaberite stavku jelovnika',
      alreadyMapped: 'već mapirano',
      articleIdPlaceholder: 'npr. 516',
      articleIdHelp: 'Numerički ili tekstualni ID artikla u POS-u. Mora se točno podudarati s onim što POS koristi.',
      articleCodePlaceholder: 'npr. LIMONA-25',
      articleCodeHelp: 'Opcionalno — interni kod artikla (ako POS koristi).',
      categoryIdPlaceholder: 'npr. 15',
      articleIdRequired: 'POS Article ID je obavezan.',
      addTitle: 'Dodaj mapiranje artikla',
      editTitle: 'Uredi mapiranje artikla',
      formDescription:
        'Mapiranje povezuje jednu stavku jelovnika s jednim artiklom u POS-u. Po lokaciji može postojati samo jedno mapiranje po stavki.',
      deleteTitle: 'Ukloniti mapiranje?',
      deleteWarning:
        'Stavka jelovnika ostaje, ali se neće slati POS-u kao prepoznati artikl. Možete ponovno mapirati u svakom trenutku.',
      errorLoading: 'Greška pri učitavanju mapiranja',
      errorLoadingMenu: 'Greška pri učitavanju jelovnika',
      errorSaving: 'Greška pri spremanju mapiranja',
      errorDeleting: 'Greška pri brisanju mapiranja',
      errorAvailability: 'Greška pri promjeni dostupnosti na ovoj lokaciji'
    }
  },
  broadcast: {
    title: 'Pošalji poruku',
    targetAudience: 'Primatelji',
    allMyCustomers: 'Svi moji korisnici',
    targetHelp: 'Odaberite objekt za slanje samo korisnicima tog objekta, ili ostavite prazno za sve.',
    filterByLocation: 'Filtriraj po lokaciji',
    allLocations: 'Sve lokacije',
    messageTitle: 'Naslov poruke',
    titlePlaceholder: 'npr. Posebna ponuda!',
    messageBody: 'Tekst poruke',
    bodyPlaceholder: 'Unesite tekst poruke koji će korisnici vidjeti...',
    send: 'Pošalji',
    sending: 'Slanje...',
    success: 'Poruka uspješno poslana!',
    noUsers: 'Nema korisnika za slanje. Korisnici moraju prvo napraviti narudžbu.',
    noDevices: 'Korisnici nemaju registrirane uređaje za push notifikacije.',
    failed: 'Slanje nije uspjelo',
    error: 'Greška pri slanju poruke',
    statsText: 'Rezultat',
    statsUsers: 'korisnika',
    statsDevices: 'uređaja',
    statsSent: 'poslano'
  },
  purchase: {
    title: 'Unesi kupnju',
    userIdentifier: 'Email ili telefon korisnika',
    userIdentifierPlaceholder: 'npr. korisnik@email.com ili +385...',
    userIdentifierHelp: 'Unesite email adresu ili broj telefona korisnika',
    location: 'Lokacija',
    selectLocation: 'Odaberite lokaciju',
    amount: 'Iznos kupnje',
    amountPlaceholder: '0.00',
    amountHelp: 'Korisnik će dobiti {points} bodova (1 bod za svakih 10€)',
    description: 'Opis (opcionalno)',
    descriptionPlaceholder: 'npr. Kupnja na blagajni',
    submit: 'Dodaj bodove',
    submitting: 'Spremanje...',
    success: 'Kupnja uspješno zabilježena!',
    error: 'Greška pri unosu kupnje',
    resultUser: 'Korisnik',
    resultPoints: 'Dodano bodova',
    resultTotal: 'Ukupno bodova'
  },
  payments: {
    tab: 'Online plaćanje',
    title: 'Online plaćanje',
    lead: 'Omogućite kartično plaćanje u mobilnoj aplikaciji prije nego narudžba stigne na blagajnu. Bez integracije korisnici i dalje mogu naručiti i platiti na lokaciji.',
    noIntegration: 'Online plaćanje nije postavljeno',
    noIntegrationDescription: 'Vlasnik projekta je odabrao ovaj payment provider u Postavkama projekta. Sada povežite ovaj objekt.',
    noIntegrationLockedHint: 'Ovaj objekt koristi payment provider odabran u Postavkama projekta.',
    addNamedIntegration: 'Postavi {name}',
    projectProviderUnset: 'Payment provider projekta nije odabran',
    projectProviderUnsetHint: 'Vlasnik projekta mora odabrati Monri, Corvus Pay ili Stripe u Moj profil → Postavke projekta prije nego ovaj objekt može povezati plaćanje.',
    providerChosenInProjectSettings: 'Postavljeno za cijeli projekt u Postavkama projekta.',
    establishmentOwnMerchantHint: 'Unesite merchant račun ovog objekta — ne račun vlasnika projekta.',
    addIntegration: 'Postavi online plaćanje',
    editIntegration: 'Uredi postavke',
    deleteIntegration: 'Ukloni integraciju',
    saveIntegration: 'Spremi postavke',
    provider: 'Payment provider',
    selectProvider: 'Odaberite provider',
    chooseProvider: 'Odaberite provider',
    chooseProviderHelp: 'Jedan online provider po objektu. Kasnije ga možete zamijeniti brisanjem i novom integracijom.',
    providerLockedHint: 'Provider se ne može promijeniti nakon kreiranja.',
    credentials: 'Pristupni podaci',
    credentialsEditHint: 'Tajni podaci su spremljeni i iz sigurnosnih razloga se ne prikazuju. Polja ostavi prazna da zadržiš postojeće vrijednosti.',
    credentialSavedPlaceholder: 'Spremljeno — ostavi prazno da zadržiš',
    credentialSavedBadge: 'Spremljeno',
    credentialsGenericIntro: 'Unesite podatke koje ste dobili od payment providera.',
    monriCredentialsIntro: 'Authenticity token i merchant key (Key) dobivate u Monri merchant dashboardu (ipgtest.monri.com / ipg.monri.com).',
    corvusCredentialsIntro: 'Store ID i Secret Key dobivate u Corvus Pay Merchant Portalu.',
    stripeCredentialsIntro: 'Stripe Connect onboarding se odvija u ovom tabu. Platformski API ključevi se ne unose.',
    settingsTitle: 'Postavke naplate',
    currency: 'Valuta',
    currencyHelp: 'Valuta u kojoj se naplaćuje online checkout.',
    testMode: 'Test / sandbox način rada',
    testModeHelp: 'Uključeno = testno okruženje providera. Isključeno = produkcija.',
    monriTestModeHelp: 'Uključeno = Monri TEST (ipgtest.monri.com). Isključeno = produkcija (ipg.monri.com).',
    stripeTestModeFromProject: 'Sandbox ili live postavlja se u Moj profil → Postavke projekta za Stripe račun ovog projekta.',
    isActive: 'Online plaćanje aktivno',
    portalSetupTitle: 'Koraci u portalu providera',
    portalSetupHelp: 'Nakon spremanja, registrirajte webhook URL u portalu providera:',
    monriPortalSetupHelp: 'U Monri dashboardu trebate samo authenticity token i merchant key. Return URL uz plaćanje u appu šaljemo sami — ništa ne trebate lijepiti za lokalni rad.',
    webhookUrl: 'Webhook URL',
    webhookUrlHelp: 'Kopirajte ovaj URL u portal providera kako bi potvrde plaćanja stizale na backend.',
    monriCallbackUrl: 'Callback URL (opcionalno)',
    monriCallbackUrlHelp: 'Samo za produkciju s javnim HTTPS poslužiteljem. U Monri dashboardu pod Callback URL zalijepite ovu adresu ako želite da Monri javi uplatu i kad kupac zatvori aplikaciju.',
    corvusWebhookUrlHelp: 'U Corvus Merchant Portalu postavite success/postback URL na ovu adresu.',
    stripeWebhookUrlHelp: 'U Stripe Dashboard → Webhooks dodajte ovaj endpoint i event checkout.session.completed.',
    monriAuthenticityToken: 'Authenticity token',
    monriAuthenticityTokenHelp: 'Authenticity token iz Monri merchant postavki.',
    monriMerchantKey: 'Merchant key',
    monriMerchantKeyHelp: 'Key / merchant key iz Monri API postavki — čuva se sigurno na poslužitelju.',
    corvusStoreId: 'Store ID',
    corvusStoreIdHelp: 'Identifikator trgovine u Corvus Pay Merchant Portalu.',
    corvusSecretKey: 'Secret Key',
    corvusSecretKeyHelp: 'Tajni ključ za HMAC potpis — čuva se sigurno na poslužitelju.',
    corvusCheckoutBaseUrl: 'Checkout URL (opcionalno)',
    corvusCheckoutBaseUrlHelp: 'Ostavite prazno za test-wallet / wallet.corvuspay.com prema test načinu.',
    corvusCheckoutBaseUrlPlaceholder: 'https://wallet.corvuspay.com/checkout',
    corvusApiVersion: 'API verzija (opcionalno)',
    corvusApiVersionHelp: 'Default je 1.4 ako ostavite prazno.',
    corvusApiVersionPlaceholder: '1.4',
    stripeSecretKey: 'Secret key',
    stripeSecretKeyHelp: 'Stripe Secret key (sk_test_… ili sk_live_…).',
    stripeWebhookSecret: 'Webhook signing secret',
    stripeWebhookSecretHelp: 'whsec_… iz Stripe webhook endpointa — potreban za provjeru potpisa.',
    stripePublishableKey: 'Publishable key (opcionalno)',
    stripePublishableKeyHelp: 'pk_test_… / pk_live_… — za mobilni SDK u budućnosti, nije obavezan za hosted checkout.',
    checkoutLanguage: 'Jezik checkouta',
    checkoutLanguageHelp: 'ISO kod jezika na payment formi (npr. hr, en).',
    checkoutLanguagePlaceholder: 'hr',
    flowStepConfigure: 'Postavite provider',
    flowStepCheckout: 'Korisnik plati u appu',
    flowStepOrder: 'Narudžba stigne plaćena',
    cashOnSiteNote: 'Bez online integracije korisnici mogu i dalje naručiti i platiti gotovinom/karticom na blagajni.',
    statusOnlineActive: 'Online plaćanje je uključeno',
    statusOnlineActiveHint: 'Korisnici u aplikaciji vide opciju kartičnog plaćanja pri checkoutu.',
    statusOnlinePending: 'Dovršite Stripe onboarding',
    statusOnlinePendingHint:
      'Integracija je spremljena, ali korisnici neće vidjeti kartično plaćanje dok identifikacija nije dovršena.',
    statusOnlineInactive: 'Online plaćanje je isključeno',
    statusOnlineInactiveHint: 'Integracija je spremljena, ali nije aktivna — korisnici plaćaju samo na lokaciji.',
    updatedAt: 'Zadnje ažurirano',
    testConnection: 'Testiraj vezu',
    testConnectionOk: 'Veza s providerom uspjela',
    testConnectionFail: 'Test veze nije uspio — provjerite pristupne podatke',
    oneTimeWebhookSecretWarning: 'Kopirajte webhook secret sada — više se neće prikazati. Koristi se za opcionalnu provjeru webhooka.',
    dismissSecret: 'Zatvori',
    copy: 'Kopiraj',
    copied: 'Kopirano u međuspremnik',
    copyFailed: 'Kopiranje nije uspjelo',
    yes: 'Da',
    no: 'Ne',
    fillRequiredCredentials: 'Popunite sva obvezna polja pristupnih podataka.',
    confirmDelete: 'Ukloniti online plaćanje?',
    confirmDeleteWarning: 'Korisnici više neće moći platiti karticom u aplikaciji. Narudžbe s plaćanjem na lokaciji i dalje rade.',
    integrationCreated: 'Online plaćanje uspješno postavljeno',
    integrationUpdated: 'Postavke plaćanja ažurirane',
    integrationDeleted: 'Online plaćanje uklonjeno',
    errorLoading: 'Greška pri učitavanju postavki plaćanja',
    errorSaving: 'Greška pri spremanju postavki plaćanja',
    errorDeleting: 'Greška pri uklanjanju integracije',
    providersLoadWarning: 'Popis providera s poslužitelja nije dostupan — prikazujemo poznate opcije.',
    monriSetup1: 'U Monri dashboardu (API settings) kopirajte authenticity token i merchant key.',
    monriSetup2: 'Test način uključite za ipgtest.monri.com, isključite za produkciju.',
    monriSetup3: 'Return URL šaljemo sami uz svako plaćanje u appu. U dashboardu ga ne trebate lijepiti.',
    corvusSetup1: 'U Corvus Merchant Portalu postavite postback / success URL.',
    corvusSetup2: 'Provjerite Store ID i Secret Key.',
    corvusSetup3: 'Za sandbox koristite test portal i uključite test način rada.',
    stripeSetup1: 'Kreirajte webhook endpoint u Stripe Dashboardu s URL-om ispod.',
    stripeSetup2: 'Pretplatite se na event checkout.session.completed.',
    stripeSetup3: 'Kopirajte signing secret (whsec_…) u polje Webhook signing secret.',
    connectTitle: 'Stripe Connect',
    connectLead: 'Dovršite identifikaciju (OIB, dokumenti, bankovni račun) ovdje. Status se ažurira automatski nakon Stripe potvrde.',
    connectStart: 'Postavi Stripe',
    connectContinue: 'Dodajte informacije',
    connectHostedHint: 'Otvara Stripeovu hosted setup stranicu (connect.stripe.com/setup/…). Ako se tab zaglavi na embedded/loading, koristite Chrome ili Safari.',
    connectAccountId: 'ID povezanog računa',
    connectReadyHint: 'Stripe transfers su aktivni. Gosti mogu platiti karticom kad je online plaćanje uključeno za ovaj objekt.',
    connectErrorStatus: 'Nije moguće učitati Stripe Connect status.',
    connectErrorStart: 'Nije moguće pokrenuti Stripe onboarding.',
    connectPlatformDisconnected: 'Vlasnik projekta mora povezati Stripe račun u Profil → Postavke projekta prije nego ovaj objekt može započeti onboarding.',
    connectStatus: {
      not_started: 'Nije započeto',
      in_progress: 'U tijeku',
      action_required: 'Potrebna radnja',
      active: 'Aktivno',
    },
    errors: {
      generic: 'Operacija plaćanja nije uspjela. Provjerite konfiguraciju.',
      credentials_missing: 'Nedostaju obavezni pristupni podaci za plaćanje.',
      provider_unsupported: 'Odabrani payment provider nije podržan.',
      integration_missing: 'Payment integracija za ovaj objekt nije pronađena.',
      checkout_failed: 'Checkout nije uspio. Provjerite Shop ID, Secret Key i test/produkcijski način.',
      webhook_invalid: 'Webhook potpis nije valjan.',
      connect_not_ready: 'Stripe plaćanje nije dostupno dok objekt ne dovrši Stripe Connect onboarding.',
    },
  },
  ordering: {
    tab: 'Naručivanje i dostava',
    title: 'Naručivanje i dostava',
    lead: 'Odredite mogu li korisnici preuzeti narudžbu na lokaciji ili zatražiti dostavu u mobilnoj aplikaciji.',
    edit: 'Uredi postavke',
    fulfillmentOptions: 'Načini isporuke',
    pickupEnabled: 'Preuzimanje na lokaciji',
    pickupEnabledHint: 'Korisnik preuzima narudžbu u vašem objektu.',
    deliveryEnabled: 'Dostava',
    deliveryEnabledHint: 'Korisnik unosi adresu dostave u aplikaciji.',
    fulfillmentHelp: 'Barem jedna opcija mora biti uključena. Dostava je opcionalna i prema zadanim postavkama isključena.',
    deliverySettings: 'Postavke dostave',
    deliveryFee: 'Naknada za dostavu (€)',
    minimumOrder: 'Minimalni iznos za dostavu (€)',
    onlineRequiredForDelivery: 'Za dostavu obavezno online plaćanje',
    onlineRequiredHelp: 'Kad je uključeno, dostava se plaća online; gotovina na licu mjesta ostaje za preuzimanje.',
    atLeastOneOption: 'Uključite preuzimanje ili dostavu (ili oboje).',
    saving: 'Spremanje…',
    loadError: 'Greška pri učitavanju postavki naručivanja.',
    saveError: 'Greška pri spremanju postavki naručivanja.',
  },
  menus: {
    title: 'Ponuda',
    items: 'stavki',
    itemsOne: 'stavka',
    itemsFew: 'stavke',
    itemsMany: 'stavki',
    addCategory: 'Dodaj kategoriju',
    addItem: 'Dodaj stavku',
    editCategory: 'Uređivanje kategorije',
    newCategory: 'Dodaj kategoriju',
    editItem: 'Uređivanje stavke menija',
    newItem: 'Dodavanje nove stavke menija',
    newCategoryTitle: 'Nova kategorija',
    categoryData: 'Podaci o kategoriji',
    newItemTitle: 'Nova stavka menija',
    itemData: 'Podaci o stavci',
    backToMenu: 'Natrag na meni',
    categoryName: 'Naziv kategorije',
    categoryNamePlaceholder: 'npr. Predjela, Glavna jela, Deserti...',
    categoryDescription: 'Opis kategorije',
    categoryDescriptionPlaceholder: 'Opcionalni opis kategorije',
    itemName: 'Naziv stavke',
    itemNamePlaceholder: 'npr. Pileći burger, Tiramisu...',
    itemDescription: 'Opis stavke',
    itemDescriptionPlaceholder: 'Opcionalni opis stavke',
    price: 'Cijena (€)',
    orderNumber: 'Redni broj',
    image: 'Slika',
    activeCategory: 'Aktivna kategorija',
    categoryHelp: 'Naziv kategorije koji će biti prikazan u meniju',
    categoryDescHelp: 'Neobavezni opis koji pobliže objašnjava sadržaj kategorije',
    orderHelp: 'Određuje redoslijed kategorije u meniju (niži broj = prikazuje se ranije)',
    activeHelp: 'Neaktivne kategorije neće biti prikazane korisnicima',
    categoryRequired: 'Odaberite kategoriju',
    itemHelp: 'Naziv stavke koji će biti prikazan u meniju',
    itemDescHelp: 'Neobavezni opis koji detaljnije opisuje stavku, npr. sastojci',
    priceHelp: 'Unesite cijenu u eurima (npr. 5.99)',
    imageHelp: 'Opcionalno, dodajte sliku koja predstavlja ovu stavku menija',
    itemOrderHelp: 'Određuje redoslijed prikazivanja u kategoriji (niži broj = prikazuje se ranije)',
    deleteCategory: 'Obriši kategoriju',
    confirmDeleteCategory: 'Jeste li sigurni da želite obrisati kategoriju',
    confirmDeleteCategoryWarning: 'Ova akcija će sakriti kategoriju iz menija. Sve stavke kategorije će također biti sakrivene.',
    confirmDeleteItem: 'Jeste li sigurni da želite obrisati stavku',
    confirmDeleteItemWarning: 'Ova akcija će sakriti stavku iz menija.',
    noCategories: 'Nema kategorija',
    noCategoriesDescription: 'Ovaj objekt još nema definiranih kategorija. Počnite dodavanjem nove kategorije.',
    noItems: 'Ova kategorija nema stavki. Dodajte novu stavku.',
    manageMenus: 'Upravljajte jelovnicima i cjenicima za vaše objekte',
    loadingEstablishments: 'Učitavanje objekata...',
    noEstablishments: 'Nema dostupnih objekata',
    createEstablishmentFirst: 'Prvo morate kreirati objekt da biste mogli dodavati ponudu.',
    categoriesCount: 'kategorija',
    activeLocationsLabel: 'aktivnih lokacija',
    viewMenu: 'Pregledaj ponudu',
    noCategoriesToView: 'Nema kategorija. Dodajte prvo novu kategoriju da biste mogli pregledati ponudu.',
    cardGlobalScope: 'Globalna ponuda za objekt',
    cardLocationScope: 'Ponuda po lokacijama',
    cardEmptyDescription: 'Ponuda je prazna. Otvorite pregled ponude i dodajte prvu kategoriju.',
    cardGlobalModeDescription: 'U pregledu uređujete kategorije i stavke koje vrijede za sve lokacije objekta.',
    cardLocationModeDescription: 'U pregledu birate lokaciju i uređujete njezine override postavke ponude uz globalni fallback.',
    saveCategory: 'Spremi kategoriju',
    saveMenuItem: 'Spremi stavku',
    outOfStock: 'Nedostupno',
    markAsAvailable: 'Označi kao dostupno',
    outOfStockHelp: 'Označite ako proizvod trenutno nije dostupan. Korisnici na mobilnoj aplikaciji će vidjeti da je proizvod nedostupan.',
    posBadgeSynced: 'POS: {id}',
    posBadgeSyncedTooltip: 'Stavka je povezana s blagajnom (POS artikl {id}) i može se fiskalizirati.',
    posBadgeMissing: 'Nije mapirano',
    posBadgeMissingTooltip: 'Stavka nema POS artikl — neće se prikazati na mobilnoj aplikaciji i ne može se naručiti dok se ne mapira u kartici "POS mapiranja menu stavki".',
    posSectionTitle: 'Veza s blagajnom (POS)',
    posSectionHint: 'Upiši ID artikla iz Remaris blagajne kako bi se ova stavka mogla fiskalizirati i pojavila u mobilnoj aplikaciji za naručivanje. Ostavi prazno da ukloniš vezu.',
    posArticleId: 'POS Article ID',
    posArticleIdPlaceholder: 'npr. 4711',
    posArticleIdHelp: 'Numerički ID artikla u Remaris sustavu (obavezno za fiskalizaciju).',
    posArticleCode: 'POS Article Code',
    posArticleCodePlaceholder: 'opcionalno',
    posArticleCodeHelp: 'Opcionalni šifra/kod artikla iz Remarisa.',
    posUnmappedWarning: 'Ova stavka trenutno nije povezana s blagajnom — bit će vidljiva samo u backofficeu, ali neće biti naručiva s mobilne aplikacije.',
    posModeBannerTitle: 'Ponuda dolazi s blagajne (POS)',
    posModeBannerBody:
      'Nove artikle i cijene dodaješ/mijenjaš na Remaris blagajni, zatim sinkroniziraš na lokaciji. Ovdje možeš doraditi sliku, opis i dostupnost. Mapiranje artikala služi da povežeš Lylup stavku s postojećim ID-jem na blagajni (npr. kad sync ne pogodi 1:1) — ne kreira proizvod na blagajni.',
    posModeBannerCta: 'Otvori POS na lokaciji',
    posModeCreateBlocked:
      'Uz aktivnu POS integraciju nove kategorije i stavke se ne dodaju ovdje — koristite sinkronizaciju s blagajne.',
    posModeCatalogLockedHint:
      'Naziv i cijena dolaze s blagajne. Promjene u Lylupu ne pišu natrag u Remaris; sljedeći sync može ih prepisati.',
    posModeMappedFieldsLocked: 'Ova polja upravlja blagajna. Uredi sliku, opis ili dostupnost ispod.',
    posModeDeleteCategoryHint: 'Sakrij u Lylupu (sljedeći sync vraća kategoriju ako još postoji na blagajni)',
    posModeDeleteItemHint: 'Sakrij u Lylupu (sljedeći sync vraća stavku ako još postoji na blagajni)',
    posModeEditCategoryHint: 'Uredi opis i redoslijed (naziv dolazi s blagajne)',
    posModeEditItemHint: 'Uredi sliku, opis i dostupnost (naziv i cijena dolaze s blagajne)',
    specialPrice: 'Posebna cijena (€)',
    specialPriceHelp: 'Opcionalna snižena cijena (npr. akcijska). Ako je prazno, koristi se redovna cijena.',
    specialPriceValidFrom: 'Posebna cijena vrijedi od',
    specialPriceValidTo: 'Posebna cijena vrijedi do',
    specialPricePeriodHelp: 'Odaberi period u kojem je posebna cijena aktivna. Izvan tog perioda koristi se redovna cijena.',
    generateQr: 'Generiraj QR kod',
    qrModalTitle: 'QR kod stavke',
    specialPriceDateRequired: 'Kada je postavljena posebna cijena, obavezni su datum od i datum do.',
    specialPriceDateOrder: 'Datum do posebne cijene mora biti nakon datuma od.',
    status: 'Status',
    available: 'Dostupno',
    moveUp: 'Pomakni gore',
    moveDown: 'Pomakni dolje',
    selectLocation: 'Lokacija za pregled i uređivanje',
    locationFallbackGlobal: 'Globalni meni (fallback)',
    categoryScopeHint: 'Kategorije su globalne za objekt; ovdje biraš lokacijski kontekst za pregled i povratak.',
    categoryFormLocationContextLabel: 'Dodajete/uređujete kategoriju za lokaciju:',
    orderFieldsTitle: 'Polja narudžbe',
    orderFieldsHint: 'Opcionalna polja koja će korisnik kasnije birati kod narudžbe (datum, vrijeme, odabir opcija, množitelj).',
    orderFieldsEmpty: 'Još nema polja. Dodaj polje ako želiš prikupljati dodatne podatke uz ovu stavku.',
    orderFieldsAdd: 'Dodaj polje',
    orderFieldRemove: 'Ukloni polje',
    orderFieldTitle: 'Naslov polja',
    orderFieldKind: 'Tip polja',
    fieldKindDate: 'Datum',
    fieldKindTime: 'Vrijeme',
    fieldKindPicker: 'Odabir (opcije)',
    fieldKindMultiplier: 'Množitelj',
    fieldDateRequired: 'Obavezno polje za korisnika',
    fieldTimeMode: 'Način',
    fieldTimeSingle: 'Jedno vrijeme',
    fieldTimeRange: 'Raspon (od–do)',
    fieldMultMin: 'Minimum',
    fieldMultMax: 'Maksimum',
    fieldMultStep: 'Korak',
    fieldPickerSubtype: 'Podtip odabira',
    pickerSubtypeOption: 'Opcije (cjenik)',
    pickerSubtypeDuration: 'Trajanje rezervacije',
    pickerSubtypeLabel: 'Label + karta',
    fieldLabelRepeat: 'Višestruki odabir (repeat)',
    fieldLabelRepeatSection: 'Višestruki odabir (repeat)',
    fieldLabelMapPreview: 'Pregled zone (Google karta)',
    fieldMapsKeyMissing: 'Za prikaz karte potreban je Google Maps API ključ u okruženju. GeoJSON možete unijeti ručno u polje ispod.',
    fieldMapsLoadError: 'Google karta se nije učitala. Provjerite ključ i mrežu.',
    fieldLabelMapSection: 'Karta i zona (Label)',
    fieldLabelRepeatMax: 'Najviše ponavljanja',
    fieldLabelGeoJson: 'GeoJSON sloja na karti',
    fieldLabelGeoInvalid: 'GeoJSON nije valjan ili se ne može prikazati.',
    fieldChoicesHeading: 'Opcije / redovi (Type)',
    fieldChoiceAdd: 'Dodaj red',
    fieldChoiceName: 'Naziv',
    fieldChoiceOp: 'Operator',
    fieldChoiceValue: 'Vrijednost',
    fieldReservationMinutes: 'Trajanje rezervacije (min)'
  },
  forms: {
    save: 'Spremi promjene',
    saving: 'Spremanje...',
    cancel: 'Odustani',
    validationReady: 'Sva obvezna polja su ispunjena — spremno za spremanje.',
    completeRequiredFields: 'Ispunite obvezna polja za spremanje.',
    submitDisabledHint: 'Ispunite sva obvezna polja prije spremanja.',
    formActions: 'Radnje obrasca',
    delete: 'Obriši',
    category: 'Kategorija',
    selectCategory: 'Odaberite kategoriju kojoj pripada ova stavka',
    deleteConfirmation: 'Potvrda brisanja',
    errorSaving: 'Došlo je do greške pri spremanju. Molimo pokušajte ponovno.',
    errorLoading: 'Greška pri učitavanju',
    errorDeleting: 'Došlo je do greške pri brisanju. Molimo pokušajte ponovno.',
    loading: 'Učitavanje...',
    validationErrors: {
      invalidEmail: 'Unesite valjanu email adresu',
      priceGreaterThanZero: 'Cijena mora biti veća od 0',
      nameRequired: 'Molimo unesite naziv',
      emailRequired: 'Molimo unesite email'
    },
    warningKicker: 'Upozorenje',
    deleteWarningGeneric: 'Ova radnja je nepovratna i ne može se poništiti.',
    slugLabel: 'URL slug',
    slugHint: 'Ovo je čisti dio URL-a (npr. zagreb-cafe-bar). Automatski se generira iz naziva; možeš ga prilagoditi. Stari linkovi nastavljaju raditi.',
    slugInvalid: 'Slug može sadržavati samo mala slova, brojeve i crtice (-), bez razmaka i posebnih znakova.',
    slugTaken: 'Ovaj slug je već zauzet. Probaj nešto drugo.'
  },
  analytics: {
    title: 'Analitika',
    totalRevenue: 'Ukupni prihod',
    totalOrders: 'Ukupno narudžbi',
    averageOrder: 'Prosječna narudžba',
    revenueByDay: 'Prihod po danu',
    topProducts: 'Najprodavaniji proizvodi',
    ordersByStatus: 'Narudžbe po statusu',
    dateFrom: 'Datum od',
    dateTo: 'Datum do',
    applyFilter: 'Primijeni',
    product: 'Proizvod',
    quantitySold: 'Prodano kom',
    revenue: 'Prihod',
    noData: 'Nema podataka za odabrano razdoblje',
    loading: 'Učitavanje analitike...',
    ordersShort: 'narudžbi',
    status_pending: 'Na čekanju',
    status_confirmed: 'Potvrđeno',
    status_in_process: 'U pripremi',
    status_ready: 'Spremno',
    status_completed: 'Završeno',
    status_rejected: 'Odbijeno',
    status_canceled: 'Otkazano',
    viewMore: 'Prikaži više',
    viewLess: 'Prikaži manje',
    guest: 'Gost',
    loadingOrders: 'Učitavanje narudžbi...',
    noOrdersForStatus: 'Nema narudžbi za ovaj status u odabranom razdoblju'
  },
  pagination: {
    prev: 'Prethodna',
    next: 'Sljedeća',
    showing: 'Prikazano',
    to: 'do',
    of_total: 'od',
    entries: 'zapisa'
  },
  general: {
    loading: 'Učitavanje...',
    error: 'Greška',
    back: 'Natrag',
    cancel: 'Odustani',
    save: 'Spremi',
    search: 'Pretraži',
    noResults: 'Nema rezultata',
    success: 'Uspjeh',
    confirm: 'Potvrdi',
    metadata: 'Metapodaci',
    id: 'ID',
    created: 'Kreirano',
    updated: 'Ažurirano',
    delete: 'Obriši',
    uploadError: 'Greška pri učitavanju slike',
    viewAll: 'Prikaži sve',
    retry: 'Pokušaj ponovno',
    actions: 'Akcije',
    create: 'Kreiraj',
    edit: 'Uredi',
    yes: 'Da',
    no: 'Ne'
  },
  common: {
    loading: 'Učitavanje...',
    cancel: 'Odustani',
    save: 'Spremi',
    delete: 'Obriši',
    edit: 'Uredi',
    view: 'Pregledaj',
    remove: 'Ukloni',
    back: 'Natrag',
    name: 'Naziv',
    email: 'Email',
    active: 'Aktivno',
    actions: 'Akcije',
    errorOccurred: 'Došlo je do pogreške',
    viewerReadOnlyError: 'Ova radnja nije dopuštena: na projektu ste u ulozi samo za pregled (read-only).',
    projectApi: {
      unauthorized: 'Niste autentificirani. Odjavite se i prijavite ponovno.',
      viewerReadonly: 'Na ovom projektu imate samo pregled — ova radnja nije dopuštena.',
      forbiddenLocation: 'Nemate pristup odabranoj lokaciji u ovom projektu.',
      accessCheckFailed: 'Provjera pristupa nije uspjela. Pokušajte ponovno.'
    },
    retry: 'Pokušaj ponovno',
    imageTooLarge: 'Slika je prevelika (max 5 MB)',
    successDelete: 'Stavka uspješno izbrisana',
    successCreate: 'Stavka uspješno kreirana',
    successUpdate: 'Stavka uspješno ažurirana',
    saving: 'Spremanje...',
    localeHr: 'HR',
    localeEn: 'EN',
    contentLocaleHint: 'Jezik sadržaja za posjetitelje (hr / en).'
  },
  news: {
    title: 'Novosti',
    manageNews: 'Upravljajte novostima i obavijestima za vaše objekte',
    addNews: 'Dodaj novost',
    addNewsTitle: 'Nova novost',
    editNewsTitle: 'Uredi novost',
    allEstablishments: 'Svi objekti',
    establishment: 'Objekt',
    selectEstablishment: 'Odaberi objekt',
    basicInfo: 'Osnovne informacije',
    content: 'Sadržaj',
    images: 'Slike',
    addImage: 'Dodaj sliku',
    uploadImage: 'Učitaj sliku',
    startDate: 'Datum početka',
    endDate: 'Datum završetka',
    fromDate: 'Od',
    untilDate: 'Do',
    validityPeriod: 'Razdoblje važenja',
    titlePlaceholder: 'Naslov novosti',
    contentPlaceholder: 'Sadržaj novosti...',
    noNews: 'Nema novosti',
    addFirstNews: 'Dodajte prvu novost za ovaj objekt',
    confirmDelete: 'Jeste li sigurni da želite izbrisati ovu novost?',
    notFound: 'Novost nije pronađena',
    uploading: 'Učitavanje...',
    imagePreview: 'Pregled slike',
    saveNews: 'Spremi novost'
  },
  profile: {
    title: 'Moj profil',
    description: 'Pregledajte i upravljajte svojim profilom i postavkama.',
    personalInfo: 'Osobni podaci',
    personalInfoDesc: 'Vaši osnovni podaci računa',
    name: 'Ime i prezime',
    email: 'Email',
    phone: 'Telefon',
    role: 'Uloga',
    city: 'Grad',
    memberSince: 'Član od',
    changePassword: 'Promjena lozinke',
    changePasswordDesc: 'Ažurirajte svoju lozinku za pristup računu',
    currentPassword: 'Trenutna lozinka',
    currentPasswordPlaceholder: 'Unesite trenutnu lozinku',
    newPassword: 'Nova lozinka',
    newPasswordPlaceholder: 'Najmanje 6 znakova',
    confirmPassword: 'Potvrdi lozinku',
    confirmPasswordPlaceholder: 'Ponovite novu lozinku',
    passwordMismatch: 'Lozinke se ne podudaraju.',
    passwordSuccess: 'Lozinka je uspješno promijenjena.',
    savePassword: 'Spremi lozinku',
    saving: 'Spremam...',
    companyInfo: 'Podaci o tvrtki',
    companyInfoDesc: 'Informacije o vašoj tvrtki',
    companyName: 'Naziv tvrtke',
    companyAddress: 'Adresa tvrtke',
    profilePhoto: 'Profilna slika',
    profilePhotoDesc: 'Vidljiva u sučelju nakon što je račun odobren.',
    avatarAfterApproval: 'Profilnu fotografiju možete dodati nakon što administrator odobri vašu registraciju.',
    uploadAvatar: 'Učitaj sliku',
    removeAvatar: 'Ukloni sliku',
    avatarUploading: 'Učitavanje...',
    avatarSaved: 'Profilna slika je spremljena.',
    avatarRemoved: 'Profilna slika je uklonjena.',
    projectSettingsTitle: 'Postavke projekta',
    projectSettingsDesc: 'Ovdje možete mijenjati samo loyalty razine i postavke preporuke prijatelja za projekt na kojem ste u sustavu zapisani kao vlasnik.',
    projectSettingsSelectProject: 'Trenutačno nema projekta za koji ste vlasnik ili kontekst nije učitan. Obratite se administratoru.',
    projectSettingsLoading: 'Učitavanje projekata…'
  },
  auth: {
    notAuthenticated: 'Niste prijavljeni. Molimo prijavite se prije nastavka.',
    notRegistered: 'Niste registrirani?',
    registerAsAdmin: 'Registrirajte se kao administrator',
    privacyPolicy: 'Pravila privatnosti',
    login: {
      subtitle: 'Prijava u administracijski panel',
      emailLabel: 'Email',
      emailPlaceholder: 'Unesite vaš email',
      passwordLabel: 'Lozinka',
      passwordPlaceholder: 'Unesite vašu lozinku',
      signIn: 'Prijava',
      signingIn: 'Prijava u tijeku...',
      errorGeneric: 'Došlo je do pogreške pri prijavi'
    },
    forgotPassword: {
      link: 'Zaboravljena lozinka?',
      subtitle: 'Unesite email za reset lozinke',
      emailLabel: 'Email',
      emailPlaceholder: 'vas@email.com',
      submit: 'Pošalji link',
      sending: 'Šaljem...',
      success: 'Ako postoji račun s tim emailom, poslat ćemo vam link za reset lozinke. Provjerite pristiglu poštu.',
      backToLogin: 'Natrag na prijavu'
    },
    resetPassword: {
      subtitle: 'Postavite novu lozinku',
      newPassword: 'Nova lozinka',
      newPasswordPlaceholder: 'Najmanje 6 znakova',
      confirmPassword: 'Potvrdi lozinku',
      confirmPlaceholder: 'Ponovite lozinku',
      passwordMismatch: 'Lozinke se ne podudaraju.',
      submit: 'Postavi lozinku',
      submitting: 'Postavljam...',
      success: 'Lozinka je uspješno postavljena.',
      backToLogin: 'Prijavite se',
      invalidLink: 'Link za reset je nevažeći ili je istekao.',
      requestNew: 'Zatražite novi link.'
    }
  },
  admins: {
    title: 'Administratori',
    pendingApproval: 'Čeka odobrenje',
    noPendingAdmins: 'Nema administratora na čekanju',
    noPendingAdminsMessage: 'Trenutno nema administratora koji čekaju odobrenje',
    approve: 'Odobri',
    reject: 'Odbij',
    rejected: 'Odbijeno',
    suspended: 'Suspendiran',
    approveConfirm: 'Jeste li sigurni da želite odobriti ovog administratora?',
    rejectConfirm: 'Jeste li sigurni da želite odbijiti ovog administratora?',
    rejectReason: 'Razlog odbijanja (opcionalno)',
    rejectReasonPlaceholder: 'Navedite razlog zašto se registracija odbija. Administrator će primiti ovaj tekst putem emaila.',
    search: 'Pretraži administratore...',
    noActiveAdmins: 'Nema aktivnih administratora',
    noActiveAdminsMessage: 'U sustavu nije pronađen nijedan aktivni administrator',
    companyName: 'Tvrtka',
    status: 'Status',
    adminActions: 'Akcije',
    createdAt: 'Datum kreiranja',
    manageAdmins: 'Upravljanje administratorskim računima',
    details: 'Detalji administratora',
    personalInfo: 'Osobni podaci',
    companyInfo: 'Podaci o firmi',
    companyOIB: 'OIB tvrtke',
    licenseInfo: 'Podaci o licenci',
    licenseActive: 'Licenca aktivna',
    licenseExpires: 'Licenca ističe',
    maxEstablishments: 'Maksimalan broj objekata',
    licenseExpired: 'Licenca istekla',
    licenseSuspended: 'Licenca suspendirana',
    licenseInactive: 'Licenca nije aktivna',
    noLicense: 'Nema licence',
    licenseType: 'Vrsta licence',
    licenseTypeBasic: 'Osnovna',
    licenseTypePremium: 'Premium',
    licenseTypeEnterprise: 'Enterprise',
    licenseExpiryDate: 'Datum isteka',
    licenseMaxEstablishments: 'Maks. broj objekata',
    licenseNote: 'Napomena',
    licenseStatus: 'Status licence',
    editLicense: 'Uredi licencu',
    editLicenseSuccess: 'Licenca je uspješno ažurirana',
    approvalLicenseSection: 'Postavke licence',
    approveSuccess: 'Administrator je uspješno odobren',
    rejectSuccess: 'Administrator je uspješno odbijen',
    projectManagement: 'Upravljanje projektima',
    projectPublicKey: 'Javni ključ',
    selectAdminForProject: 'Odaberi admina',
    projectCreated: 'Projekt je uspješno kreiran',
    projectDeleted: 'Projekt je uspješno obrisan',
    deleteProjectTitle: 'Brisanje projekta',
    deleteProjectConfirmBefore: 'Obrisati projekt',
    deleteProjectConfirmAfter: ' i sve povezane podatke (objekte, lokacije, narudžbe, izbornik, novosti, promo kodove, komplekse i ostalo)?',
    deleteProjectConfirmIrreversible: 'Ova radnja je nepovratna.',
    adminAssignedToProject: 'Admin je dodijeljen projektu',
    adminRemovedFromProject: 'Admin je uklonjen s projekta',
    noProjectAdmins: 'Još nema dodijeljenih admina.',
    activeProject: 'Aktivni projekt',
    copyKey: 'Kopiraj ključ',
    projectKeyCopied: 'Ključ projekta je kopiran',
    selectProjectForApproval: 'Projekt za odobrenje',
    selectProjectForApprovalPlaceholder: 'Odaberi projekt prije odobravanja',
    createNewProjectOption: 'Kreiraj novi projekt',
    newProjectNamePlaceholder: 'Unesi naziv novog projekta',
    projectSelectionRequired: 'Prije odobravanja moraš odabrati projekt',
    newProjectNameRequired: 'Unesi naziv za novi projekt',
    approvalMembershipRole: 'Uloga na projektu',
    assignMembershipRole: 'Uloga pri dodjeli',
    roleProjectOwner: 'Vlasnik projekta',
    roleContributor: 'Suradnik (contributor)',
    roleViewer: 'Pregled (samo čitanje)',
    navPending: 'Na odobrenju',
    navDirectory: 'Popis administratora',
    navProjects: 'Projekti i tim',
    inviteAdmin: 'Pozovi admina',
    inviteHint: 'Pozvani admin dobiva email s linkom za postavljanje lozinke. Licenca i projekt se dodjeljuju odmah — nakon accepta račun je aktivan.',
    inviteFirstName: 'Ime',
    inviteLastName: 'Prezime',
    inviteEmail: 'Email',
    inviteFirstNameRequired: 'Unesi ime',
    inviteLastNameRequired: 'Unesi prezime',
    inviteEmailRequired: 'Unesi ispravan email',
    inviteProjectRequired: 'Prije slanja invitea moraš odabrati projekt',
    sendInvite: 'Pošalji invite',
    inviteSuccess: 'Pozivnica je poslana na email',
    invited: 'Pozvan',
    resendInvite: 'Ponovno pošalji',
    resendInviteSuccess: 'Invite email je ponovno poslan',
    revokeInvite: 'Poništi invite',
    revokeInviteConfirm: 'Jeste li sigurni da želite poništiti ovaj invite?',
    revokeInviteSuccess: 'Invite je poništen',
    acceptInvite: {
      subtitle: 'Postavite lozinku za LYLUP admin portal',
      submit: 'Aktiviraj račun',
      success: 'Račun je aktiviran',
      successHint: 'Sada se možete prijaviti u admin portal.',
      goToLogin: 'Idi na prijavu',
      invalidLink: 'Invite link je nevažeći ili nedostaje.',
      error: 'Aktivacija nije uspjela. Pokušajte ponovno.',
    },
    projectRolesColumn: 'Projekti i uloge',
    projectsHelpShort: 'Otvori projekt za ključeve za API, dodavanje članova i promjenu uloga u tablici tima.',
    membersCountSuffix: 'člana',
    accessKeysSection: 'Ključevi i UUID (integracije)',
    addMemberSection: 'Dodaj ili ažuriraj člana',
    addMemberHint: 'Ako je admin već na projektu, odabirom druge uloge i potvrdom odmah mijenjaš ulogu — ne trebaš ga ponovno dodavati kao novog člana.',
    addMemberSubmit: 'Dodaj ili spremi ulogu',
    teamSection: 'Tim na projektu',
    roleUpdated: 'Uloga je ažurirana',
    detailNoProjectMemberships: 'Nije dodijeljen niti na jedan projekt.',
    detailAddToProject: 'Dodaj na projekt',
    memberRoleLabel: 'Uloga',
    loyaltyLevelsSection: 'Loyalty razine',
    loyaltyLevelsHint: 'Konfigurirajte razine i pragove bodova za ovaj projekt.',
    levelName: 'Ime razine',
    levelNamePlaceholder: 'npr. Platinum',
    minPoints: 'Min. bodova',
    addLevel: 'Dodaj razinu',
    loyaltyLevelsSaved: 'Razine su uspješno spremljene',
    levelNameRequired: 'Sve razine moraju imati ime',
    levelNameDuplicate: 'Imena razina moraju biti jedinstvena',
    pointsScopeSection: 'Način skupljanja bodova',
    pointsScopeHint: 'Odaberite kako se bodovi prate — po pojedinom objektu/kompleksu ili zajednički za cijeli projekt.',
    pointsScopeEstablishment: 'Po objektu / kompleksu (zasebni saldi)',
    pointsScopeProject: 'Po projektu (jedan zajednički saldo)',
    pointsScopeSaved: 'Način skupljanja bodova je spremljen',
    pointsScopeEstablishmentDescription: 'Korisnik ima zasebne bodove za svaki objekt (ili kompleks ako je kompleks postavljen na zajednički saldo). Bodove može trošiti samo tamo gdje ih je skupio.',
    pointsScopeProjectDescription: 'Korisnik ima jedan zajednički saldo za cijeli projekt. Bodove skuplja i troši na bilo kojem objektu unutar projekta.',
    pointsProgramSection: 'Loyalty program',
    pointsProgramHint: 'Odaberite jedan od 4 programa za cijeli projekt. Objekti nasljeđuju ovu postavku; stope bodova i dalje se postavljaju po objektu.',
    pointsProgramSaved: 'Loyalty program je spremljen',
    pointsProgramOrderEstablishment: 'Narudžba + po objektu',
    pointsProgramOrderProject: 'Narudžba + po projektu',
    pointsProgramCardEstablishment: 'Kartica + po objektu',
    pointsProgramCardProject: 'Kartica + po projektu',
    pointsProgramOrderEstablishmentDescription: 'Bodovi se automatski dodjeljuju nakon narudžbe. Korisnik ima zaseban saldo po objektu.',
    pointsProgramOrderProjectDescription: 'Bodovi se automatski dodjeljuju nakon narudžbe. Korisnik ima jedan zajednički saldo za cijeli projekt.',
    pointsProgramCardEstablishmentDescription: 'Bodovi se dodjeljuju skeniranjem kartice ili ručnim unosom. Korisnik ima zaseban saldo po objektu.',
    pointsProgramCardProjectDescription: 'Bodovi se dodjeljuju skeniranjem kartice ili ručnim unosom. Korisnik ima jedan zajednički saldo za cijeli projekt.',
    referralSection: 'Pozovi prijatelja',
    referralHint: 'Omogućite preporuke za ovaj projekt i definirajte koliko bodova dobiva preporučitelj nakon što se prijatelj registrira s njegovim kodom. Opcionalno dodajte bodove i novom korisniku (dobrodošlica).',
    referralEnabled: 'Uključi preporuke prijatelja',
    referralReferrerPoints: 'Bodovi za preporučitelja',
    referralRefereePoints: 'Bodovi za novog korisnika (dobrodošlica)',
    referralSaved: 'Postavke preporuke su spremljene',
    referralReferrerMin: 'Kad je preporuka uključena, preporučitelj mora imati barem 1 bod.',
    onlinePaymentsSection: 'Online plaćanje',
    onlinePaymentsHint: 'Odaberite jedini payment provider koji objekti ovog projekta mogu koristiti. Monri i Corvus Pay: svaki objekt povezuje vlastiti merchant račun. Stripe: objekti rade Connect onboarding na vašem Stripe računu.',
    onlinePaymentsChooseHelp: 'Aktivan je jedan provider. Možete ga promijeniti u bilo kojem trenutku; prethodno spremljeni podaci ostaju i ponovno se koriste ako se vratite na taj provider.',
    onlinePaymentsSaved: 'Payment provider projekta je spremljen',
    onlinePaymentsSaveFailed: 'Spremanje payment providera nije uspjelo',
    onlinePaymentsSave: 'Spremi payment provider',
    gatewayCredentialsSection: 'Merchant podaci (po objektu)',
    gatewayCredentialsHint:
      'Odabirom Monri ili Corvus Pay omogućujete taj provider za sve objekte projekta. Svaki objekt zatim unosi vlastiti merchant račun u Objekt → Online plaćanje.',
    gatewayCredentialsEstablishmentNote:
      'Ova polja se ne unose ovdje. Otvorite Online plaćanje na svakom objektu da povežete merchant račun tog objekta.',
    stripeConnectSection: 'Povežite svoj Stripe račun',
    stripeConnectHint: 'Sandbox ili live restricted key (rk_) i publishable key (pk_). Objekti zatim rade Connect KYC na tom računu.',
    stripeSandbox: 'Sandbox (test)',
    stripeLive: 'Live',
    stripePublishableKey: 'Publishable key',
    stripeRestrictedKey: 'Restricted key',
    stripeRestrictedKeyHelp: 'Koristite restricted key (rk_test_ / rk_live_). Sprema se šifrirano i više se ne prikazuje.',
    stripePaymentWebhookSecret: 'Webhook secret za plaćanja (opcionalno)',
    stripeConnectWebhookSecret: 'Webhook secret za Connect (opcionalno)',
    stripePaymentWebhookUrl: 'Webhook URL za plaćanja',
    stripeConnectWebhookUrl: 'Webhook URL za Connect',
    stripeWebhookHelp: 'Zalijepite ove URL-ove u Stripe Dashboard webhooks, zatim spremite signing secrets ovdje.',
    stripeKeysNeverEchoed: 'Restricted key i webhook secrets se nakon spremanja nikad ne vraćaju.',
    stripeConnectSubmit: 'Testiraj vezu i spremi',
    stripeConnectUpdate: 'Testiraj i ažuriraj',
    stripeConnectSaved: 'Stripe račun je povezan',
    stripeConnectFailed: 'Povezivanje Stripe računa nije uspjelo',
    stripeConnected: 'Povezano',
    stripeNotConnected: 'Nije povezano',
  },
  rewards: {
    title: 'Upravljanje nagradama',
    pageSubtitle: 'Kreirajte i upravljajte nagradama za sve razine loyalty programa',
    descriptionLabel: 'Opis nagrade',
    points: 'bodova',
    requiredLevel: 'Potrebna razina',
    level: 'Razina',
    createReward: 'Dodaj nagradu',
    createTitle: 'Kreiranje nove nagrade',
    editTitle: 'Uređivanje nagrade',
    searchPlaceholder: 'Pretraži nagrade...',
    allStatus: 'Svi statusi',
    activeStatus: 'Aktivno',
    inactiveStatus: 'Neaktivno',
    allLevels: 'Sve razine',
    levelBronze: 'Bronze',
    levelSilver: 'Silver',
    levelGold: 'Gold',
    levelRemoved: 'uklonjena',
    forAllLevels: 'Za sve razine',
    noRewardsFound: 'Nema pronađenih nagrada',
    noRewardsFoundMessage: 'Nije pronađena niti jedna nagrada koja odgovara vašem pretraživanju.',
    name: 'Naziv',
    namePlaceholder: 'Unesite naziv nagrade',
    descriptionPlaceholder: 'Opišite nagradu i što korisnik dobiva',
    pointsRequired: 'Potrebni bodovi',
    status: 'Status',
    createdAt: 'Datum kreiranja',
    confirmDeleteMessage: 'Jeste li sigurni da želite obrisati ovu nagradu? Ova radnja se ne može poništiti.',
    discountValue: 'Postotak popusta',
    discountValueFixed: 'Iznos popusta (€)',
    rewardType: 'Tip nagrade',
    selectRewardType: 'Odaberite tip nagrade',
    typeCartPercent: 'Popust na košaricu (%)',
    typeCartFixed: 'Fiksni popust na košaricu (€)',
    typeItemPercent: 'Popust na artikal (%)',
    typeFreeItem: 'Besplatni artikal',
    typeInStore: 'Samo na licu mjesta',
    menuItem: 'Artikal iz jelovnika',
    selectMenuItem: 'Odaberite artikal',
    menuItemRequired: 'Odaberite artikal za ovaj tip nagrade',
    menuItemLoading: 'Učitavanje artikala…',
    menuItemEmpty: 'Nema dostupnih artikala u meniju ovog objekta',
    valueRequired: 'Vrijednost je obavezna',
    valuePercentInvalid: 'Postotak mora biti između 0 i 100',
    valueFixedInvalid: 'Iznos mora biti veći od 0',
    establishment: 'Objekt',
    selectEstablishment: 'Odaberite objekt',
    selectEstablishmentFirst: 'Prvo odaberite objekt',
    selectLevel: 'Odaberite razinu',
    selectLevelRequired: 'Molimo odaberite razinu.',
    validFrom: 'Vrijedi od',
    validUntil: 'Vrijedi do',
    noStartDate: 'Bez početnog datuma',
    noEndDate: 'Bez završnog datuma',
    basicInfo: 'Osnovni podaci',
    rewardRequirements: 'Zahtjevi nagrade',
    activateReward: 'Aktiviraj nagradu',
    deactivateReward: 'Deaktiviraj nagradu',
    saveReward: 'Spremi nagradu',
    nameLocaleRequired: 'Unesite naziv na hrvatskom ili engleskom.',
    descriptionLocaleRequired: 'Unesite opis na hrvatskom ili engleskom.',
    nameLocaleTooLong: 'Naziv po jeziku ne smije biti duži od 100 znakova.'
  },
  tables: {
    manageTables: 'Upravljanje stolovima',
    backToLocation: 'Natrag na lokaciju',
    addTable: 'Dodaj stol',
    editTable: 'Uredi stol',
    tableName: 'Naziv stola',
    tableNumber: 'Broj stola',
    capacity: 'Kapacitet',
    capacityPlaceholder: 'Unesite kapacitet stola',
    noTables: 'Nema stolova',
    addTablePrompt: 'Dodajte prvi stol za ovu lokaciju',
    notSpecified: 'Nije određeno',
    batchAddTables: 'Dodaj više stolova',
    namePrefix: 'Prefiks naziva',
    namePrefixPlaceholder: 'npr. Stol',
    namePrefixHelp: 'Ovaj tekst će biti dodana ispred broja stola',
    startNumber: 'Početni broj',
    startNumberPlaceholder: 'npr. 1',
    endNumber: 'Završni broj',
    endNumberPlaceholder: 'npr. 10',
    preview: 'Pregled',
    createTables: 'Kreiraj stolove',
    generateQRCodes: 'Generiraj QR kodove',
    generateQRBatch: 'Generiraj QR kodove za stolove',
    qrCodeFor: 'QR kod za',
    selectTables: 'Odaberi stolove',
    downloadQR: 'Preuzmi QR kod',
    printQR: 'Ispiši QR kod',
    downloadAllQR: 'Preuzmi sve QR kodove',
    printAllQR: 'Ispiši sve QR kodove',
    confirmDelete: 'Potvrda brisanja',
    deleteConfirmMessage: 'Jeste li sigurni da želite izbrisati stol',
    deleteConfirmWarning: 'Ova akcija će trajno ukloniti stol i njegove QR kodove iz sustava.',
    errorDeletingTable: 'Greška pri brisanju stola',
    errorFetchingTables: 'Greška pri dohvaćanju stolova',
    errorGeneratingQR: 'Greška pri generiranju QR koda',
    errorGeneratingQRCodes: 'Greška pri generiranju QR kodova',
    errorGeneratingZIP: 'Greška pri generiranju ZIP arhive',
    errorSavingTable: 'Greška pri spremanju stola',
    errorCreatingTables: 'Greška pri kreiranju stolova',
    invalidRangeError: 'Nevažeći raspon brojeva. Početni broj mora biti manji od završnog broja i možete kreirati najviše 100 stolova odjednom.',
    locationName: 'Lokacija',
    qrCodesGenerated: 'QR kodova generirano',
    settings: 'Postavke',
    enterValidRange: 'Unesite valjan raspon brojeva',
    allTables: 'Svi stolovi',
    selectTablesToGenerate: 'Odaberite stolove za generiranje',
    selectAll: 'Odaberi sve',
    deselectAll: 'Poništi odabir'
  },
  employees: {
    title: 'Zaposlenici',
    manageEmployees: 'Upravljanje zaposlenicima po lokaciji — oni u aplikaciji vide i potvrđuju narudžbe svoje lokacije.',
    createNew: 'Dodaj zaposlenika',
    inviteEmployee: 'Pozovi zaposlenika',
    inviteHint: 'Zaposlenik će dobiti email s linkom za postavljanje lozinke. Nakon toga se prijavljuje u LYLUP mobilnu aplikaciju.',
    inviteSuccess: 'Pozivnica je poslana na email',
    sendInvite: 'Pošalji pozivnicu',
    resendInvite: 'Pošalji ponovno',
    resendInviteSuccess: 'Pozivnica je ponovno poslana',
    status: 'Status',
    statusActive: 'Aktivan',
    statusPending: 'Čeka aktivaciju',
    noEmployees: 'Nema zaposlenika',
    noEmployeesMessage: 'Još nema dodanih zaposlenika. Pozovite zaposlenika klikom na gumb iznad.',
    employeeDetails: 'Detalji zaposlenika',
    newEmployee: 'Novi zaposlenik',
    editEmployee: 'Uređivanje zaposlenika',
    name: 'Ime i prezime',
    email: 'Email',
    password: 'Lozinka',
    location: 'Lokacija',
    created: 'Kreiran',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovog zaposlenika',
    deleteBlockedLastActive: 'Ne možete obrisati jedinog aktivnog zaposlenika na lokaciji',
    deleteLastActiveWarning: 'Nakon brisanja nitko u aplikaciji ne bi vidio narudžbe ove lokacije. Prvo pozovite drugog zaposlenika.',
    basicInfo: 'Osnovne informacije',
    selectLocation: 'Odaberite lokaciju',
    noLocations: 'Nema dostupnih lokacija',
    createLocationFirst: 'Prvo kreirajte lokaciju da biste mogli dodijeliti zaposlenika.',
    backToEmployees: 'Natrag na zaposlenike',
    saveEmployee: 'Spremi zaposlenika',
    passwordInfo: 'Lozinka mora imati najmanje 6 znakova',
    saveSuccess: 'Zaposlenik je uspješno spremljen',
    deleteSuccess: 'Zaposlenik je uspješno obrisan',
    search: 'Pretraži zaposlenike...',
    filterByLocation: 'Sve lokacije',
    acceptInvite: {
      subtitle: 'Postavite lozinku za zaposlenički račun',
      submit: 'Aktiviraj račun',
      success: 'Račun je aktiviran.',
      successHint: 'Prijavite se u LYLUP mobilnu aplikaciju kao zaposlenik.',
      invalidLink: 'Invite link je nevažeći ili je istekao.',
      error: 'Greška pri aktivaciji računa.'
    }
  },
  complexes: {
    title: 'Kompleksi',
    description: 'Upravljanje kompleksima (grupama objekata)',
    noComplexes: 'Još nema kompleksa. Dodajte prvi kompleks.',
    add: 'Novi kompleks',
    edit: 'Uredi kompleks',
    name: 'Naziv',
    pointsScope: 'Skupljanje bodova',
    pointsScopeEstablishment: 'Po objektu',
    pointsScopeComplex: 'Ukupno po kompleksu',
    pointsScopeEstablishmentDescription: 'Korisnik ima odvojene bodove za svaki objekt u kompleksu',
    pointsScopeComplexDescription: 'Svi objekti u kompleksu dijele jedan zajednički saldo bodova',
    establishments: 'Objekti u kompleksu',
    noEstablishments: 'Nema dodanih objekata',
    confirmDelete: 'Jeste li sigurni da želite obrisati ovaj kompleks?',
    saveComplex: 'Spremi kompleks',
    backToComplexes: 'Natrag na komplekse'
  },
  publicPages: {
    nav: {
      privacy: 'Pravila privatnosti',
      support: 'Podrška',
      marketing: 'O Lylupu',
      deleteAccount: 'Brisanje računa'
    },
    privacy: {
      title: 'Pravila privatnosti',
      lastUpdated: 'Zadnja izmjena: 24. srpnja 2026.',
      intro:
        'Ova Pravila privatnosti opisuju kako prikupljamo, koristimo i štitimo vaše podatke prilikom korištenja mobilne aplikacije Lylup.',
      cameraTitle: 'Korištenje kamere',
      cameraIntro: 'Aplikacija koristi kameru uređaja u sljedeće svrhe:',
      cameraScanTitle: 'Skeniranje QR kodova i barkodova:',
      cameraScanBody:
        'Kamerom skeniramo QR kodove i barkodove kako biste brže otvorili digitalne menije, evidentirali loyalty aktivnost i iskoristili nagrade. Tok kamere obrađuje se na uređaju — ne pohranjujemo niti šaljemo slike kamere radi skeniranja.',
      cameraPhotoTitle: 'Snimanje fotografija:',
      cameraPhotoBody:
        'Aplikacija može koristiti kameru za snimanje fotografija (npr. profilna slika) samo kada vi eksplicitno pokrenete tu radnju. Fotografije se pohranjuju u skladu s vašim pristankom i postavkama računa.',
      cameraNote:
        'Pristup kameri je opcionalan. Ako odbijete dopuštenje, značajke koje zahtijevaju skeniranje ili snimanje neće biti dostupne.',
      collectTitle: 'Koje podatke prikupljamo',
      collectBody:
        'Prikupljamo podatke koje unesete pri registraciji (ime, e-mail, telefon i povezana polja profila), loyalty aktivnost (bodovi, nagrade, transakcije), podatke o narudžbama te tehničke podatke uređaja potrebne za push obavijesti i stabilnost aplikacije.',
      useTitle: 'Kako koristimo podatke',
      useBody:
        'Podatke koristimo za vođenje loyalty programa, obradu nagrada i narudžbi, slanje relevantnih obavijesti, unaprjeđenje usluge, korisničku podršku te ispunjavanje zakonskih obveza.',
      shareTitle: 'Dijeljenje podataka',
      shareBody:
        'Ne prodajemo vaše osobne podatke. Podatke možemo dijeliti s partnerskim objektima (za loyalty i narudžbe) te pružateljima usluga koji pomažu u radu, uz obvezu povjerljivosti i samo u mjeri potrebnoj za pružanje usluge.',
      securityTitle: 'Sigurnost podataka',
      securityBody:
        'Primjenjujemo odgovarajuće tehničke i organizacijske mjere kako bismo zaštitili osobne podatke od neovlaštenog pristupa, izmjene ili gubitka.',
      rightsTitle: 'Vaša prava',
      rightsBody:
        'Ovisno o mjerodavnom pravu, možete zatražiti pristup, ispravak, brisanje, ograničenje, prigovor ili prenosivost podataka te povući pristanak gdje se obrada temelji na pristanku. Brisanje računa možete zatražiti putem stranice Brisanje računa ili kontaktom.',
      contactTitle: 'Kontakt',
      contactBody:
        'Za pitanja o ovim Pravilima privatnosti ili vašim podacima kontaktirajte nas na info@gauss.hr ili putem stranice Podrška.'
    },
    support: {
      title: 'Podrška',
      intro:
        'Trebate pomoć s Lylupom? Obratite se našem timu za račun, bodove, narudžbe ili zahtjeve vezane uz privatnost.',
      howTitle: 'Kako nas kontaktirati',
      howEmail: 'E-mail: info@gauss.hr',
      howPhone: 'Telefon: +385 95 342 9600',
      howApp: 'U aplikaciji: koristite Račun za profil, bodove i povijest narudžbi.',
      topicsTitle: 'S čime možemo pomoći',
      topicAccount: 'Prijava, registracija i ažuriranje profila',
      topicPoints: 'Stanje bodova, nagrade i preporuke prijatelja',
      topicOrders: 'Narudžbe, dostava/preuzimanje i status plaćanja',
      topicPrivacy: 'Zahtjevi vezani uz privatnost i brisanje računa',
      cta: 'Pišite nam i navedite e-mail povezan s vašim Lylup računom:'
    },
    marketing: {
      title: 'Lylup',
      intro:
        'Lylup je mobilna loyalty aplikacija za skupljanje bodova, pregled partnerskih ponuda, naručivanje u sudjelujućim objektima i korištenje nagrada.',
      featuresTitle: 'Što možete raditi',
      featurePoints: 'Skupljati i pratiti loyalty bodove kod partnerskih lokacija',
      featureOrders: 'Naručivati za preuzimanje ili dostavu gdje je dostupno',
      featureOffers: 'Pregledavati menije, promocije i vijesti omiljenih objekata',
      featureScan: 'Skenirati kodove za brži loyalty i pristup meniju',
      featureReferral: 'Pozvati prijatelje i ostvariti nagrade za preporuku (gdje je omogućeno)',
      whoTitle: 'Za koga je',
      whoBody:
        'Lylup je namijenjen gostima restorana i ugostiteljskih objekata koji vode digitalni loyalty program. Aplikaciju razvija Gauss d.o.o.',
      cta: 'Saznajte više o Gaussu:'
    },
    deleteAccount: {
      title: 'Brisanje Lylup računa',
      intro:
        'Možete zatražiti trajno brisanje Lylup računa i povezanih osobnih podataka. Nakon brisanja gubite pristup bodovima, povijesti narudžbi i spremljenim podacima profila.',
      stepsTitle: 'Kako zatražiti brisanje',
      step1: 'Pošaljite e-mail na info@gauss.hr s adrese povezane s vašim Lylup računom.',
      step2: 'U predmetu navedite „Zahtjev za brisanje Lylup računa“ te uključite ime i prezime i broj telefona iz aplikacije.',
      step3: 'Potvrdit ćemo zahtjev i obrisati račun, uobičajeno unutar 30 dana.',
      whatTitle: 'Što se briše',
      whatBody:
        'Brišemo ili anonimiziramo podatke profila, saldo bodova vezan uz korisnika te osobnu povijest narudžbi koja više nije potrebna za uslugu.',
      retainTitle: 'Što možemo zadržati',
      retainBody:
        'Ograničene zapise možemo zadržati kada to zakon nalaže (npr. porezni ili platni zapisi) ili radi sprječavanja zlouporabe, na najkraći potreban rok.',
      cta: 'Zatražite brisanje računa:',
      mailSubject: 'Zahtjev za brisanje Lylup računa'
    }
  }
}
